import { throttle } from 'lodash';
import store from 'store/dist/store.modern';
import { SearchHelper } from './search.helper';

const searchHistoryStore = store.namespace('searchHistory');

export function keywordFilter(keyword) {
  return keyword
    .replace(/\n/gm, '')
    .replace(/\s+/g, ' ')
    .trim();
}

class SearchHistoryModel {
  constructor(max = 10) {
    this._key = 'search_history';
    this._max = max;
    this.init();
  }

  init() {
    const current = searchHistoryStore.get(this._key);
    if (!current || !Array.isArray(current)) searchHistoryStore.set(this._key, []);
  }

  get() {
    return searchHistoryStore.get(this._key);
  }

  set(histories) {
    searchHistoryStore.set(this._key, histories);
  }

  add(keyword) {
    if (!keyword.length) return;
    const current = this.get();
    if (current.includes(keyword)) current.splice(current.indexOf(keyword), 1);
    current.unshift(keyword);
    this.set(current.slice(0, this._max));
  }

  remove(keyword) {
    const current = this.get();
    if (current.includes(keyword)) {
      current.splice(current.indexOf(keyword), 1);
      this.set(current);
    }
  }

  clear() {
    this.set([]);
  }

  isEmpty() {
    return !this.get().length;
  }

  getFirst(number) {
    return this.get().slice(0, number);
  }
}

export default class SearchHistory extends SearchHelper {
  constructor({
    $wrapper,
    $list,
    $template,
    $btnClearAll,
    $btnTurnOffHistory = null,
    $btnTurnOnHistory = null,
    updateViewCallback = null,
  }, max) {
    super($wrapper);

    this.model = new SearchHistoryModel(max);
    this.hasHistoryToggleButtons = ($btnTurnOffHistory && $btnTurnOffHistory.length > 0)
      && ($btnTurnOnHistory && $btnTurnOnHistory.length > 0);
    this.isSearchHistoryOpen = false;
    this.isHistoryDisabled = (this.hasHistoryToggleButtons && searchHistoryStore.get('isHistoryDisabled')) || false;
    this.$list = $list;
    this.$template = $template;
    this.$btnClearAll = $btnClearAll;
    this.$btnTurnOffHistory = $btnTurnOffHistory;
    this.$btnTurnOnHistory = $btnTurnOnHistory;
    this.updateViewCallback = updateViewCallback;
    this.maxCount = max;

    this.init();
  }

  init() {
    this.updateView();
    this.setEvents();
  }

  setEvents() {
    this.$btnClearAll.on('click', () => {
      if (Ridi.globals.isPaper && !window.confirm('검색 기록을 모두 삭제하시겠습니까?')) {
        return;
      }
      this.model.clear();
      this.updateView();
    });
    if (this.useHighlight) {
      this.$wrapper.on('mouseover', 'li', throttle(e => this.hoverListEvent(e), 100));
    }
    if (this.hasHistoryToggleButtons) {
      this.$btnTurnOffHistory.on('click', () => {
        this.isHistoryDisabled = true;
        searchHistoryStore.set('isHistoryDisabled', true);
        this.updateView();
      });
      this.$btnTurnOnHistory.on('click', () => {
        this.isHistoryDisabled = false;
        searchHistoryStore.set('isHistoryDisabled', false);
        this.updateView();
      });
    }
  }

  isOpen() {
    return this.isSearchHistoryOpen;
  }

  renderList() {
    this.$list.empty();
    if (this.model.isEmpty()) return;
    this.model.getFirst(this.maxCount ? this.maxCount : 5).forEach((keyword, idx) => {
      this.$template.clone()
        .attr('data-index', idx)
        .find('.js_link')
        .text(keyword)
        .attr('href', `/search/?q=${keyword}`)
        .end()
        .find('.js_btn_del_history')
        .on('click', () => this.removeListEvent(keyword))
        .end()
        .appendTo(this.$list);
    });
  }

  updateView() {
    if (this.model.isEmpty()) {
      this.close();
    }

    if (this.isHistoryDisabled) {
      this.$wrapper.addClass('history_disabled');
    } else {
      this.$wrapper.removeClass('history_disabled');
      this.renderList();
    }

    if (this.updateViewCallback) {
      this.updateViewCallback(this.model.isEmpty());
    }
  }

  open() {
    if (this.model.isEmpty()) {
      return;
    }
    this.$wrapper.show();
    this.isSearchHistoryOpen = true;
  }

  close() {
    this.$wrapper.hide();
    this.clearHighlight();
    this.isSearchHistoryOpen = false;
  }

  add(keyword) {
    if (this.isHistoryDisabled || !keyword.length) {
      return;
    }
    this.model.add(keywordFilter(keyword));
  }

  remove(keyword) {
    this.model.remove(keyword);
    this.updateView();
  }

  hoverListEvent(e) {
    e.preventDefault();
    this.setHighlightAt($(e.currentTarget).data('index'), this.$wrapper.find('.highlight'));
  }

  removeListEvent(keyword) {
    this.remove(keyword);
  }

  bindOnKeywordClick(onKeywordClick) {
    this.$wrapper.on('click', '.js_link', onKeywordClick);
  }

  getTargetSearchUrl() {
    return this.$wrapper
      .find('.highlight')
      .find('.js_link')
      .attr('href');
  }

  getUpperBound() {
    return this.$list.children('li').length;
  }

  static isEnabled() {
    return store.enabled;
  }
}



// WEBPACK FOOTER //
// ./common/search.history.js